module.exports = __webpack_public_path__ + "media/images/home/home_img2-fc5a742d5f43d6aeda028a40d0b580cd.jpg";